module.exports = __webpack_public_path__ + "static/media/terminal.d61642e3.png";